// extracted by mini-css-extract-plugin
export default {"footer":"euy1t","user-info":"VRkGE","userInfo":"VRkGE","text":"KR7xk","links-container":"IxFvH","linksContainer":"IxFvH","link-wrapper":"_edaf","linkWrapper":"_edaf","link":"Y4S8r"};